import { Component, h, EventEmitter, Event, Prop } from '@stencil/core';
import { environment } from '../../global/resources';
import { convertToBase64 } from '../../utils/utils';

@Component({
  tag: 'mo-offer-frame',
  styleUrl: 'mo-offer-frame.css',
  shadow: true,
})
export class MoOfferFrame {
  public urlWidget: string = environment.widget_url;
  public urlBase: string = environment.base_url;

  @Prop() clientId!: string;
  @Prop() price: string;

  @Event({
    eventName: 'closeIframe',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  closeIframe: EventEmitter<boolean>;

  private closeIframeHandler = () => {
    this.closeIframe.emit(true);
  };

  render() {
    return (
      <div class='mo-offer-frame-overlay'>
        <div class='mo-offer-frame-overlay__container'>
          <img
            onClick={this.closeIframeHandler}
            class='close-icon'
            src={`${this.urlBase}/assets/close_white.svg`}
            alt='Close Icon'
          />
          <iframe
            id='mo-offer-iframe'
            src={
              !!this.price && this.price !== 'undefined'
                ? `${this.urlWidget}/?clientId=${convertToBase64(this.clientId)}&price=${
                    this.price
                  }`
                : `${this.urlWidget}/?clientId=${convertToBase64(this.clientId)}`
            }
            frameborder='0'
          ></iframe>
        </div>
      </div>
    );
  }
}
